export default class RequestLogService {
	constructor(apiService) {
		this.apiService = apiService
	}

	getEntities(params) {
		return this.apiService.callGet('request_logs', params)
	}

	getEntity(id, params) {
		return this.apiService.callGet('request_logs/' + id, params)
	}
}



// WEBPACK FOOTER //
// ./src/service/RequestLogService.js